<template>
  <div class="qcc-history-container">
    <div class="search-section">
      <el-form :inline="true" size="small" :model="queryForm" @keyup.enter.native="handleSearch()">
        <el-form-item label="完整的公司名称" prop="companyKey">
          <el-input
              v-model="queryForm.companyKey"
              placeholder="请输入完整公司名称"
              clearable
              size="small"
              style="width: 250px;"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleSearch()">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
        :data="historyList"
        stripe
        v-loading="loading"
        style="width: 100%;">
      <el-table-column
          prop="name"
          header-align="center"
          align="center"
          label="公司名称"
          width="300">
      </el-table-column>
      <el-table-column
          prop="companyId"
          header-align="center"
          align="center"
          label="公司ID"
          width="300">
      </el-table-column>
      <el-table-column
          prop="result"
          header-align="center"
          align="center"
          label="排查结果"
          width="200">
        <template slot-scope="scope">
          <span v-if="scope.row.result == 0" style="color: green;">低风险</span>
          <span v-if="scope.row.result == 1" style="color: orange;">中风险</span>
          <span v-if="scope.row.result == 2" style="color: red;">高风险</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="createTime"
          header-align="center"
          align="center"
          label="创建时间"
          width="200">
      </el-table-column>
      <el-table-column
          fixed="right"
          header-align="center"
          align="center"
          width="500"
          label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="viewDetails(scope.row)" style="margin-right: 15px;">
            查看详情
          </el-button>
          <el-button type="text" size="small" @click="viewInvestigationReport(scope.row)" style="margin-right: 15px;">
            查看历史排查结果
          </el-button>
          <el-button type="text" v-if="isAuth('qcc:qccHistory:view')"  size="small" @click="viewAttachments(scope.row)" style="margin-right: 15px;">
            查看附件
          </el-button>
          <el-button type="text" v-if="isAuth('qcc:qccHistory:manage')" size="small" @click="manageAttachments(scope.row)">
            管理附件
          </el-button>
        </template>
      </el-table-column>
    </el-table>


    <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>

    <!-- 详情弹窗 -->
    <el-dialog title="排查详情" :visible.sync="detailDialogVisible" width="80%" append-to-body>
      <div v-if="selectedRecord">
        <h4>公司信息</h4>
        <p><strong>名称：</strong>{{ selectedRecord.name }}</p>
        <p><strong>ID：</strong>{{ selectedRecord.companyId }}</p>
        <p><strong>排查结果：</strong>
          <span :style="{ color: getResultColor(selectedRecord.result) }">{{ getResultText(selectedRecord.result) }}</span>
        </p>
        <p><strong>创建时间：</strong>{{ selectedRecord.createDate }}</p>

        <h4 v-if="parsedSelectedOriginalHits">维度命中情况</h4>
        <el-table v-if="parsedSelectedOriginalHits" :data="parsedSelectedOriginalHits" style="width: 100%; margin-bottom: 20px;">
          <el-table-column prop="key" label="维度Key" width="150"></el-table-column>
          <el-table-column prop="name" label="维度名称"></el-table-column>
          <el-table-column prop="level" label="风险等级" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.level == 1" style="color: orange;">关注风险</span>
              <span v-if="scope.row.level == 2" style="color: red;">警示风险</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalHits" label="维度命中数" width="100"></el-table-column>
        </el-table>

        <h4 v-if="parsedSelectedCreditRateResult">信用分</h4>
        <div v-if="parsedSelectedCreditRateResult" class="credit-info">
          <p><strong>分数：</strong>{{ parsedSelectedCreditRateResult.Score }}</p>
          <p><strong>描述：</strong>{{ parsedSelectedCreditRateResult.ScoreDescInfo }}</p>
        </div>
      </div>
    </el-dialog>

    <!-- 准入排查报告弹窗 -->
    <el-dialog title="准入排查报告" :visible.sync="reportDialogVisible" width="90%" append-to-body>
      <div style="height: 80vh;">
        <iframe id="reportIframe" ref="reportIframe" frameborder="0" style="width: 100%; height: 100%;" allowfullscreen></iframe>
      </div>
    </el-dialog>

    <!-- 附件管理弹窗 -->
    <el-dialog title="附件管理" :visible.sync="attachmentDialogVisible" width="70%" append-to-body>
      <FileUpDown2 ref="attachmentManager" :bizId="currentRecordId"
                   :bizType="36" :viewFlag="attachmentViewFlag" :canDelete="attachmentCanDelete"></FileUpDown2>
    </el-dialog>
  </div>
</template>

<script>
import { searchByCompanyKey, getSign } from '@/controller/supplier';
import FileUpDown2 from "@/views/common/file-up-down";
import {isAuth} from "../../../../utils/common";
export default {
  name: 'QccHistory',
  components: {
    FileUpDown2
  },
  data() {
    return {
      queryForm: {
        companyKey: ''
      },
      historyList: [],
      loading: false,
      page: 1,
      limit: 10,
      total: 0,
      detailDialogVisible: false,
      selectedRecord: null,
      reportDialogVisible: false,
      currentReportData: {},
      attachmentDialogVisible: false,
      currentRecordId: null,
      attachmentViewFlag: 'edit',
      attachmentCanDelete: true
    }
  },
  computed: {
    // 解析选中记录的维度命中情况
    parsedSelectedOriginalHits() {
      if (this.selectedRecord && this.selectedRecord.originalHits) {
        try {
          return JSON.parse(this.selectedRecord.originalHits);
        } catch (e) {
          console.error('解析选中记录维度命中情况失败:', e);
          return null;
        }
      }
      return null;
    },
    // 解析选中记录的信用分
    parsedSelectedCreditRateResult() {
      if (this.selectedRecord && this.selectedRecord.creditRateResult) {
        try {
          return JSON.parse(this.selectedRecord.creditRateResult);
        } catch (e) {
          console.error('解析选中记录信用分失败:', e);
          return null;
        }
      }
      return null;
    }
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    isAuth,
    /** 获取数据列表 */
    async getDataList() {
      this.loading = true;
      try {
        let params = {};
        if (this.queryForm.companyKey) {
          params = { name: this.queryForm.companyKey};
        }

        const response = await searchByCompanyKey(params);
        if (response && response.code === '00') {
          this.historyList = response.body || [];
          this.total = this.historyList.length;
        } else {
          this.$message.error(response.msg || '获取数据失败');
        }
      } catch (error) {
        console.error('获取数据失败:', error);
        this.$message.error('获取数据失败');
      } finally {
        this.loading = false;
      }
    },

    /** 搜索按钮操作 */
    handleSearch() {
      this.page = 1;
      this.getDataList();
    },

    /** 重置按钮操作 */
    resetQuery() {
      this.queryForm = {
        companyKey: ''
      };
      this.getDataList();
    },

    /** 页码改变 */
    handleCurrentChange(val) {
      this.page = val;
      this.getDataList();
    },

    /** 每页数量改变 */
    handleSizeChange(val) {
      this.limit = val;
      this.getDataList();
    },

    /** 查看详情 */
    viewDetails(record) {
      this.selectedRecord = record;
      this.detailDialogVisible = true;
    },

    /** 查看准入排查报告 */
    async viewInvestigationReport(record) {
      this.currentReportData = record;
      this.reportDialogVisible = true;

      // 等待弹窗渲染完成后再加载iframe内容
      this.$nextTick(async () => {
        await this.loadInvestigationReport();
      });
    },

    /** 加载准入排查报告 */
    async loadInvestigationReport() {
      try {
        // 调用后端API获取签名信息
        const signResponse = await getSign({});
        if (signResponse && signResponse.code === '00') {
          const {timestamp, sign} = signResponse.body;

          // 使用固定配置参数（实际应用中可能需要从系统配置中获取）
          const phone = '13863182271';
          const accessKey = 'PHCiakFKnnbCtwiYxpArTK25hz3xJj8G';

          // 从当前记录获取必要参数
          const companyId = this.currentReportData.companyId;
          const diligenceId = this.currentReportData.diligenceId || this.currentReportData.id; // 使用diligenceId或id作为排查记录id

          // 准入排查详情URL
          const redirectUrl = `https://kys.qcc.com/external/supplier/risk-investigation-history/${companyId}?from=record&diligenceId=${diligenceId}&hideAddTo=Y`;
          const fallbackUrl = 'https://kys.qcc.com/error/403';
          const host = 'https://kys.qcc.com';
          const url = `${host}/rover/account/loginRedirect?phone=${encodeURIComponent(phone)}&accessKey=${encodeURIComponent(accessKey)}&timestamp=${encodeURIComponent(timestamp)}&sign=${encodeURIComponent(sign)}&redirectUrl=${encodeURIComponent(redirectUrl)}&fallbackUrl=${encodeURIComponent(fallbackUrl)}`;

          const iframe = this.$refs.reportIframe;
          if (iframe) {
            iframe.src = url;
          }
        } else {
          this.$message.error('获取签名失败');
        }
      } catch (error) {
        console.error('加载准入排查报告失败:', error);
        this.$message.error('加载准入排查报告失败');
      }
    },

    /** 管理附件 */
    manageAttachments(record) {
      this.currentRecordId = record.companyId; // 使用companyId作为业务ID，而不是record.id
      this.attachmentViewFlag = 'edit'; // 编辑模式，允许上传和删除
      this.attachmentCanDelete = true;
      this.attachmentDialogVisible = true;

      // 在弹窗显示后初始化附件管理组件
      this.$nextTick(() => {
        if (this.$refs.attachmentManager) {
          this.$refs.attachmentManager.init(this.attachmentViewFlag);
        }
      });
    },

    viewAttachments(record) {
      this.currentRecordId = record.companyId; // 使用companyId作为业务ID，而不是record.id
      this.attachmentViewFlag = 'view'; // 查看模式，不允许上传和删除
      this.attachmentCanDelete = false;
      this.attachmentDialogVisible = true;

      // 在弹窗显示后初始化附件管理组件
      this.$nextTick(() => {
        if (this.$refs.attachmentManager) {
          this.$refs.attachmentManager.init(this.attachmentViewFlag);
        }
      });
    },

    getResultText(result) {
      switch (result) {
        case 0:
          return '低风险';
        case 1:
          return '中风险';
        case 2:
          return '高风险';
        default:
          return '未知';
      }
    },

    getResultColor(result) {
      switch (result) {
        case 0:
          return 'green';
        case 1:
          return 'orange';
        case 2:
          return 'red';
        default:
          return 'gray';
      }
    }
  }
}
</script>

<style scoped>.qcc-history-container {
  padding: 20px;
}

.search-section {
  margin-bottom: 20px;
}

.credit-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.credit-info .label {
  font-weight: bold;
  margin-right: 10px;
}

/* 增加表格操作列按钮间距 */
.el-table .el-button+.el-button {
  margin-left: 0;
}
</style>
